import React from 'react';

/**
 * SyncStatusBubble — Floating pill for email sync progress.
 *
 * Behavior:
 * - On chat page: hidden (chat renders its own inline sync log card)
 * - On other pages with active syncs: summary "N jobs syncing"
 * - No active syncs anywhere: hidden
 *
 * currentSearchId comes from SyncContext (set by ChatPage when user enters a chat session).
 */
const SyncStatusBubble = () => {
  return null;
};

export default SyncStatusBubble;
